/* eslint-disable no-unused-vars */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import React, { useRef, useState } from "react";
import { Form, Button } from "react-bootstrap";
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";

const CustomerSalesBreakDownDetails = () => {
  localStorage.setItem("menu", "StockV4");
  localStorage.setItem("submenu", "");

  const scrollRef = useRef(null);

  const [formData, setFormData] = useState({
    salesSummary: {
      quoteNo: "",
      customer: "",
      width: "",
      frameType: "",
      length: "",
      mainFrames: "",
      eaveHeight: "",
      postBeam: "",
      roofSlope: "",
      windSpeed: "",
      bayLength: "",
      liveLoad: "",
      roofArea: "",
      collateral: "",
      snow: "",
      salesDiscount: "",
    },
    categoryItems: {},
  });

  // const staticRows = [
  //   "Basic Building excluding sheeting",
  //   "Roof Sheeting",
  //   "Walls Sheeting",
  //   "Roof Liner",
  //   "Wall Liner",
  //   "Crane Beams & Brackets",
  //   "Mezzanines",
  //   "Structural Accessories"
  // ];
  const staticRows = [
    { label: "Basic Building excluding sheeting" },
    { label: "Roof Sheeting" },
    { label: "Walls Sheeting" },
    { label: "Roof Liner" },
    { label: "Wall Liner" },
    { label: "Crane Beams & Brackets" },
    { label: "Mezzanines" },
    {
      label: "Structural Accessories",
      subItems: [
        "Roof Extension",
        "Canopy",
        "Fascia",
        "Partition with Panels",
        "Stairs",
        "Handrails for Mezzanines",
        "Cage Ladder",
      ],
    },
    {
      label: "Roof Accessories",
      subItems: [
        "Insulation",
        "Skylight",
        "Roof Framed Openings",
        "Gravity Ridge Ventilator",
        "Power Ventilator",
        "Pipe Flashing",
        "Roof Curb",
      ],
    },
    {
      label: "Wall Accessories",
      subItems: [
        "Insulation",
        "Walllight",
        "Wall Framed Openings",
        "Aluminum Window",
        "Steel Louver",
        "Personnel Door",
        "Sliding Door",
      ],
    },
    {
      label: "Special Works",
      subItems: [
        "Galvanization",
        "Powder Coating",
        "Third Party Inspection / Special Testing",
        "Site Survey Charges",
        "Engineering Charges",
        "Other (Specify):",
      ],
    },
    {
      label: "Undefined Category",
      subItems: ["A: Undefined Category Items"],
    },
    { label: "Total Exwork Price", isSummary: true },
    {
      label: "Freight (Lifting Method) @ INR To Destination City, Country",
    },
    { label: "Sales Tax on supply only" },
    { label: "Insurance" },
    { label: "Financial (Extended Payment) Charges" },
    // Optional spacer row (row 18) – can be handled with styling or skipped
    { label: "Total Selling FOB Based on CFR (or) CIF", isSummary: true },
    { label: "Site Subcontracts (Erection, Paint, etc.)" },
    { label: "Social Insurance" },
    { label: "Tax on site subcontracts by ZS" },
    { label: "Grand Total", isSummary: true },
  ];

  const handleInputChange = (e, key) => {
    setFormData({ ...formData, [key]: e.target.value });
  };

  const handleCategoryChange = (desc, colKey, value) => {
    setFormData((prev) => ({
      ...prev,
      categoryItems: {
        ...prev.categoryItems,
        [desc]: {
          ...prev.categoryItems[desc],
          [colKey]: value,
        },
      },
    }));
  };
  const handleSubmit = () => {
    // console.log("Payload:", formData);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Sales Breakdown Summary</h2>
            <p className="subText">Please provide all required details.</p>
            <hr />
            <Form>
              <Row className="mb-3 border p-3">
                {/* Left Side Inputs */}
                <Col xs={12} md={8}>
                  <Row>
                    {[
                      { label: "Quote No.", name: "quoteNo" },
                      { label: "Customer", name: "customer" },
                      { label: "Width (m)", name: "width" },
                      { label: "Frame Type", name: "frameType" },
                      { label: "Length (m)", name: "length" },
                      { label: "No. of Main Frames", name: "mainFrames" },
                      { label: "Eave Height (m)", name: "eaveHeight" },
                      { label: "No. of Post & Beam", name: "postBeam" },
                      { label: "Roof Slope (x/10)", name: "roofSlope" },
                      { label: "Bay Length", name: "bayLength" },
                    ].map((field, i) => (
                      <Col
                        xs={12}
                        md={6}
                        lg={6}
                        className="commTopButtonRightLeftPadding mb-2"
                        key={i}
                      >
                        <InputField
                          className="inputBox"
                          label={field.label}
                          name={field.name}
                          value={formData[field.name] || ""}
                          onChange={(e) => handleInputChange(e, field.name)}
                          extraLabel=""
                          disabled={true} // if needed, pass extraLabel here
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>

                {/* Right Side Inputs */}
                <Col xs={12} md={4}>
                  <Row>
                    {[
                      { label: "Live Load", name: "liveLoad" },
                      { label: "Roof Area M2", name: "roofArea" },
                      { label: "Collateral", name: "collateral" },
                      { label: "Snow", name: "snow" },
                      { label: "Wind Speed", name: "windSpeed" },
                      { label: "Sales Discount (%)", name: "salesDiscount" },
                    ].map((field, i) => (
                      <Col
                        xs={12}
                        key={i}
                        className="commTopButtonRightLeftPadding mb-2"
                      >
                        <InputField
                          className="inputBox"
                          label={field.label}
                          name={field.name}
                          value={formData[field.name] || ""}
                          onChange={(e) => handleInputChange(e, field.name)}
                          extraLabel=""
                          disabled={true}
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>

                {/* Table
                <Col xs={12} className="mt-3">
                  <div
                    ref={scrollRef}
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      border: "2px solid black",
                    }}
                  >
                    <table
                      className="table table-bordered text-center align-middle small"
                      style={{ borderCollapse: "collapse", marginBottom: 0 }}
                    >
                      <thead
                        className="bg-warning text-dark"
                        style={{ position: "sticky", top: 0, zIndex: 1 }}
                      >
                        <tr>
                          <th>Item No.</th>
                          <th>Description</th>
                          <th>Weight (KG)</th>
                          <th>%</th>
                          <th>Book Price</th>
                          <th>Rate</th>
                          <th>%</th>
                          <th>Discounted</th>
                          <th>Rate</th>
                          <th>%</th>
                        </tr>
                      </thead>
                      <tbody>
                        {staticRows.map((desc, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{desc}</td>
                            {[
                              "weight",
                              "weightPercent",
                              "bookPrice",
                              "rate",
                              "bookPercent",
                              "discounted",
                              "discRate",
                              "discPercent",
                            ].map((key, i) => (
                              <td key={i}>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  style={{
                                    minWidth: "80px",
                                    height: "35px",
                                    padding: "4px 8px",
                                  }}
                                  value={formData.categoryItems[desc]?.[key] || ""}
                                  onChange={(e) =>
                                    handleCategoryChange(desc, key, e.target.value)
                                  }
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Col> */}
                {/* <Col xs={12} className="mt-3">
                  <div
                    ref={scrollRef}
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      border: "2px solid black",
                    }}
                  >
                    <table
                      className="table text-center align-middle small"
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        marginBottom: 0,
                        border: "2px solid black",
                      }}
                    >
                      <thead>
                        <tr>
                          {[
                            "Item No.",
                            "Description",
                            "Weight (KG)",
                            "%",
                            "Book Price",
                            "Rate",
                            "%",
                            "Discounted",
                            "Rate",
                            "%",
                          ].map((heading, i) => (
                            <th
                              key={i}
                              style={{
                                border: "1px solid black",
                                backgroundColor: "#ffc107",
                                color: "#000",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                                padding: "8px",
                              }}
                            >
                              {heading}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {staticRows.map((desc, index) => (
                          <tr key={index}>
                            <td style={{ border: "1px solid black", padding: "6px" }}>
                              {index + 1}
                            </td>
                            <td style={{ border: "1px solid black", padding: "6px" }}>
                              {desc}
                            </td>
                            {[
                              "weight",
                              "weightPercent",
                              "bookPrice",
                              "rate",
                              "bookPercent",
                              "discounted",
                              "discRate",
                              "discPercent",
                            ].map((key, i) => (
                              <td key={i} style={{ border: "1px solid black", padding: "6px" }}>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  style={{
                                    minWidth: "80px",
                                    height: "35px",
                                    padding: "4px 8px",
                                  }}
                                  value={formData.categoryItems[desc]?.[key] || ""}
                                  onChange={(e) =>
                                    handleCategoryChange(desc, key, e.target.value)
                                  }
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Col> */}
                <Col xs={12} className="mt-3">
                  <div
                    ref={scrollRef}
                    style={{
                      maxHeight: "500px",
                      overflowY: "auto",
                      border: "2px solid black",
                    }}
                  >
                    <table
                      className="table text-center align-middle small"
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        marginBottom: 0,
                        border: "2px solid black",
                      }}
                    >
                      <thead>
                        <tr>
                          {[
                            "Item No.",
                            "Description",
                            "Weight (KG)",
                            "%Of Total",
                            "Book Price",
                            "Rate",
                            "%Of Total",
                            "Discounted",
                            "Rate",
                            "%Of Total",
                          ].map((heading, i) => (
                            <th
                              key={i}
                              style={{
                                border: "1px solid black",
                                backgroundColor: "#ffc107",
                                color: "#000",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                                padding: "8px",
                              }}
                            >
                              {heading}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {staticRows.map((row, index) => {
                          const itemNumber = index + 1;
                          const baseKey = row.label;

                          return row.subItems ? (
                            <>
                              <tr key={baseKey}>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "6px",
                                  }}
                                >
                                  {itemNumber}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid black",
                                    padding: "6px",
                                  }}
                                >
                                  <strong>{baseKey}</strong>
                                </td>
                                <td
                                  colSpan={8}
                                  style={{ border: "1px solid black" }}
                                ></td>
                              </tr>
                              {row.subItems.map((subLabel, subIdx) => (
                                <tr key={subLabel}>
                                  <td
                                    style={{
                                      border: "1px solid black",
                                      padding: "6px",
                                    }}
                                  >
                                    {String.fromCharCode(65 + subIdx)}{" "}
                                    {/* A, B, C, etc. */}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid black",
                                      padding: "6px",
                                    }}
                                  >
                                    {subLabel}
                                  </td>
                                  {[
                                    "weight",
                                    "weightPercent",
                                    "bookPrice",
                                    "rate",
                                    "bookPercent",
                                    "discounted",
                                    "discRate",
                                    "discPercent",
                                  ].map((key, i) => (
                                    <td
                                      key={i}
                                      style={{
                                        border: "1px solid black",
                                        padding: "6px",
                                      }}
                                    >
                                      <InputField
                                        type="text"
                                        className="form-control form-control-sm"
                                        style={{
                                          minWidth: "80px",
                                          height: "35px",
                                          padding: "4px 8px",
                                        }}
                                        value={
                                          formData.categoryItems[subLabel]?.[
                                            key
                                          ] || ""
                                        }
                                        onChange={(e) =>
                                          handleCategoryChange(
                                            subLabel,
                                            key,
                                            e.target.value
                                          )
                                        }
                                        disabled={true}
                                      />
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr key={baseKey}>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "6px",
                                }}
                              >
                                {itemNumber}
                              </td>
                              <td
                                style={{
                                  border: "1px solid black",
                                  padding: "6px",
                                }}
                              >
                                {baseKey}
                              </td>
                              {[
                                "weight",
                                "weightPercent",
                                "bookPrice",
                                "rate",
                                "bookPercent",
                                "discounted",
                                "discRate",
                                "discPercent",
                              ].map((key, i) => (
                                <td
                                  key={i}
                                  style={{
                                    border: "1px solid black",
                                    padding: "6px",
                                  }}
                                >
                                  <InputField
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{
                                      minWidth: "80px",
                                      height: "35px",
                                      padding: "4px 8px",
                                    }}
                                    value={
                                      formData.categoryItems[baseKey]?.[key] ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      handleCategoryChange(
                                        baseKey,
                                        key,
                                        e.target.value
                                      )
                                    }
                                    disabled={true}
                                  />
                                </td>
                              ))}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Col>

                <Col xs={12} className="text-end mt-3">
                  <Button onClick={handleSubmit}>Submit</Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CustomerSalesBreakDownDetails;
